import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=1fc3478a&"
import script from "./Flow.vue?vue&type=script&lang=js&"
export * from "./Flow.vue?vue&type=script&lang=js&"
import style0 from "./Flow.vue?vue&type=style&index=0&id=1fc3478a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports